import { Create, Edit, List, Show } from "../Components/index.js";

export default [
    {
        path: "/property-location",
        component: List,
        name: "property.location",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property-location/create",
        component: Create,
        name: "property.location.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property-location/:id/show",
        component: Show,
        name: "property.location.show",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/property-location/:id/edit",
        component: Edit,
        name: "property.location.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
